import gql from 'graphql-tag';
export const GET_TENANT_SETTINGS = gql `
  query getTenantSettings {
    tenants {
      id
      businessName
      supportEmail
      personas {
        name
        registerRequiredFields
        localizationKey
        businessScope
      }
      apps {
      id
      name
      url
      icon
      active
      thirdParty
      }
    }
  }
`;
//# sourceMappingURL=tenantSettings.js.map